/**
 * C 端「自选股」接口；Mock 规则见前端规范。
 */
import { message } from "antd";
import { post } from "../../utils/Backend";
import { useLongfansMock } from "../../global/GlobalMock";
import type { AppUserHoldingLineDTO } from "./UserHoldingsType";
import type {
  UserWatchlistListGroupsResultDTO,
  UserWatchlistListItemsResultDTO,
} from "./UserWatchlistType";
import { UserHoldingsApi } from "./UserHoldingsApi";
import { userWatchlistMocks } from "./UserWatchlistMock";

const mockUserWatchlist = useLongfansMock && false;

const BASE = "/lark/app/userWatchlist";

export const UserWatchlistApi = {
  async listGroups(spaceId: string): Promise<UserWatchlistListGroupsResultDTO | null> {
    if (mockUserWatchlist) {
      return userWatchlistMocks.listGroups();
    }
    const r = await post<Record<string, unknown>, UserWatchlistListGroupsResultDTO>(
      `${BASE}/listGroups`,
      { spaceId },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },

  async createGroup(spaceId: string, groupName: string): Promise<UserWatchlistListGroupsResultDTO | null> {
    if (mockUserWatchlist) {
      try {
        return userWatchlistMocks.createGroup(groupName);
      } catch (e) {
        message.error(e instanceof Error ? e.message : "创建分组失败");
        return null;
      }
    }
    const r = await post<{ spaceId: string; groupName: string }, UserWatchlistListGroupsResultDTO>(
      `${BASE}/createGroup`,
      { spaceId, groupName },
      { silent: true }
    );
    if (typeof r === "string") {
      message.error(r);
      return null;
    }
    return r;
  },

  async deleteGroup(spaceId: string, groupId: string): Promise<boolean> {
    if (mockUserWatchlist) {
      userWatchlistMocks.deleteGroup(groupId);
      return true;
    }
    const ok = await post(`${BASE}/deleteGroup`, { spaceId, groupId }, { silent: true });
    return typeof ok !== "string";
  },

  async listItems(spaceId: string, groupId: string): Promise<UserWatchlistListItemsResultDTO | null> {
    if (mockUserWatchlist) {
      return userWatchlistMocks.listItems(groupId);
    }
    const r = await post<{ spaceId: string; groupId: string }, UserWatchlistListItemsResultDTO>(
      `${BASE}/listItems`,
      { spaceId, groupId },
      { silent: true }
    );
    return typeof r === "string" ? null : r;
  },

  async addItem(
    spaceId: string,
    param: { groupId: string; stockCode: string; stockName?: string; addReason: string }
  ): Promise<boolean> {
    if (mockUserWatchlist) {
      try {
        userWatchlistMocks.addItem(
          param.groupId,
          param.stockCode,
          param.stockName ?? "",
          param.addReason
        );
        return true;
      } catch {
        return false;
      }
    }
    const ok = await post(`${BASE}/addItem`, { spaceId, ...param }, { silent: true });
    return typeof ok !== "string";
  },

  async removeItem(spaceId: string, itemId: string): Promise<boolean> {
    if (mockUserWatchlist) {
      userWatchlistMocks.removeItem(itemId);
      return true;
    }
    const ok = await post(`${BASE}/removeItem`, { spaceId, itemId }, { silent: true });
    return typeof ok !== "string";
  },

  async findOpenHoldingByStock(spaceId: string, stockCode: string): Promise<AppUserHoldingLineDTO | null> {
    return UserHoldingsApi.findOpenHoldingByStock(spaceId, stockCode);
  },
};
